import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute  from "../components/auth/ProtectedRoute";
import HomePage        from "../pages/home/HomePage";
import PortalPage      from "../pages/portal/PortalPage";
import LoginPage       from "../pages/auth/LoginPage";
import AuthCallbackPage from "../pages/auth/AuthCallbackPage";
import TermsPage       from "../pages/legal/TermsPage";
import InboundLayout   from "../pages/inbound/InboundLayout";
import InboundListPage from "../pages/inbound/InboundListPage";
import AssignmentPage  from "../pages/assignment/AssignmentPage";
import EnterQtyPage    from "../pages/enterQty/EnterQtyPage";
import UploadXml       from "../pages/upload/UploadXml.js";
import HistoryPage     from "../pages/historic/HistoryPage.js";
import ShowDanfe       from "../pages/danfe/DanfePdfPage.js";
import DanfeBatchPage  from "../pages/danfe/DanfeBatchPage.js";
import DanfePrintPage  from "../pages/danfe/DanfePrintPage.js";
import EmpresasPage    from "../pages/admin/EmpresasPage.js";
import ProcessosPage   from "../pages/admin/ProcessosPage.js";
import EtapasPage      from "../pages/admin/EtapasPage.js";
import CfopPage        from "../pages/admin/CfopPage.js";
import CertificadosPage from "../pages/admin/CertificadosPage.js";
import XmlSefazPage    from "../pages/admin/XmlSefazPage.js";
import UsersPage            from "../pages/admin/UsersPage.js";
import IntegrationLogPage  from "../pages/admin/IntegrationLogPage.js";
import MessagesPage        from "../pages/admin/MessagesPage.js";
import IntegrationConfigPage from "../pages/admin/IntegrationConfigPage.js";
import AuditLogPage        from "../pages/admin/AuditLogPage.js";
import TermsVersionPage    from "../pages/admin/TermsVersionPage.js";

export default function Index() {
  return (
    <Routes>
      <Route path="/"       element={<HomePage />} />
      <Route path="/home"   element={<HomePage />} />
      <Route path="/portal" element={<PortalPage />} />
      <Route path="/login"  element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/termos" element={<TermsPage />} />
      <Route path="/termos-de-uso" element={<TermsPage />} />
      <Route path="/danfe-print/:accessKey" element={<DanfePrintPage />} />

      <Route element={<ProtectedRoute><InboundLayout /></ProtectedRoute>}>
        <Route path="/inbound"                        element={<InboundListPage />} />
        <Route path="/inbound/historic/:accessKey"    element={<HistoryPage />} />
        <Route path="/inbound/assign/:accessKey"      element={<AssignmentPage />} />
        <Route path="/inbound/enterQty/:accessKey"    element={<EnterQtyPage />} />
        <Route path="/inbound/danfe/:accessKey"       element={<ShowDanfe />} />
        <Route path="/inbound/danfe-batch"            element={<DanfeBatchPage />} />
        <Route path="/upload"                         element={<UploadXml />} />

        {/* Admin — SUPER only */}
        <Route path="/admin/empresas"     element={<ProtectedRoute roles={["SUPER"]}><EmpresasPage /></ProtectedRoute>} />
        <Route path="/admin/processos"    element={<ProtectedRoute roles={["SUPER"]}><ProcessosPage /></ProtectedRoute>} />
        <Route path="/admin/etapas"       element={<ProtectedRoute roles={["SUPER"]}><EtapasPage /></ProtectedRoute>} />
        <Route path="/admin/cfop"         element={<ProtectedRoute roles={["SUPER"]}><CfopPage /></ProtectedRoute>} />
        <Route path="/admin/certificados" element={<ProtectedRoute roles={["SUPER","ADMIN"]}><CertificadosPage /></ProtectedRoute>} />
        <Route path="/admin/xml-sefaz"    element={<ProtectedRoute roles={["SUPER","ADMIN"]}><XmlSefazPage /></ProtectedRoute>} />
        <Route path="/admin/users"        element={<ProtectedRoute roles={["SUPER","ADMIN"]}><UsersPage /></ProtectedRoute>} />
        <Route path="/admin/integration"  element={<ProtectedRoute roles={["SUPER","ADMIN"]}><IntegrationLogPage /></ProtectedRoute>} />
        <Route path="/admin/mensagens"    element={<ProtectedRoute roles={["SUPER"]}><MessagesPage /></ProtectedRoute>} />
        <Route path="/admin/integration-configs" element={<ProtectedRoute roles={["SUPER"]}><IntegrationConfigPage /></ProtectedRoute>} />
        <Route path="/admin/audit-log"    element={<ProtectedRoute roles={["SUPER","ADMIN"]}><AuditLogPage /></ProtectedRoute>} />
        <Route path="/admin/terms"        element={<ProtectedRoute roles={["SUPER"]}><TermsVersionPage /></ProtectedRoute>} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
